import {
  CHANNEL_LIST,
  CHANNEL_LIST_LOADING,
  SET_SINGLE_AUDIO,
  CHANNEL,
  CHANNEL_MESSAGE,
  CHANNEL_FILTER,
  CHANNEL_FILE,
  MESSAGE_DATA,
  MESSAGE_DATA_LOADING,
  MESSAGE_PUSH,
  MESSAGE_SAW_UPDATE,
  MESSAGE_CLEAR,
  JOIN_CHAT,
  MESSAGE_LIVE,
  MESSAGE_Index,
  MESSAGE_Upload,
  NOTIFICATIONMESSAGE,
  STATUSCODE,
  ADID,
  SEARCHCOUNT,
  ADSTYPE,
  MESSAGE_FILTER,
  DELETECHANNELS,
  SEENMESSAGE,
  SEENMESSAGEFIRST,
  UNBLOCKUSERID,
} from "../Selectors";

export const channelListReducer = (state = [], actions) => {
  switch (actions.type) {
    case CHANNEL_LIST:
      return (state = actions.payload || []);
    default:
      return state;
  }
};

export const channelListLoadingReducer = (state = true, actions) => {
  switch (actions.type) {
    case CHANNEL_LIST_LOADING:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const singleAudioReducer = (state = true, actions) => {
  switch (actions.type) {
    case SET_SINGLE_AUDIO:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const channelReducer = (state = false, actions) => {
  switch (actions.type) {
    case CHANNEL:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const channelMessageReducer = (state = false, actions) => {
  switch (actions.type) {
    case CHANNEL_MESSAGE:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const channelFilterReducer = (state = false, actions) => {
  switch (actions.type) {
    case CHANNEL_FILTER:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const channelFile = (state = false, actions) => {
  switch (actions.type) {
    case CHANNEL_FILE:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const MessageChat = (state = {}, actions) => {
  switch (actions.type) {
    case MESSAGE_DATA:
      const data = actions.payload;
      if(data) {
        const obj = {};
        data.messages.slice().reverse().some((item)=>{
          if(item.status==='unseen' && item.user_id === data.userId) {
            obj[item.id] = 1;
          } else if(item.status==='seen' && item.user_id === data.userId) {
            return true; //stop loop
          }
          return false;
        })
        // .map((item)=>{return {[item.id]:1}});
        // const obj = Object.assign({}, ...arr);
        data.unseen = obj;
      }
      return data;
    case MESSAGE_PUSH:
      if(Array.isArray(actions.payload)) {
        const messages = actions.payload.flat();
        const unseen = {...state.unseen};
        const newMessage = messages.map((item)=>{
          unseen[item.id] = 1;
          const clonedData = {...item, status: 'unseen'};
          if(clonedData.file)
          clonedData.file.details = item.url;
          return clonedData;
        });
        return {
          ...state,
          unseen: unseen,
          messages: [
            ...state.messages,
            ...newMessage
          ]
        };
      }
      break;
      case MESSAGE_CLEAR:
          return {
            ...state,
            unseen: {},
            messages: []
          };
      case MESSAGE_SAW_UPDATE:
        return {
          ...state,
          unseen: {}
        };
      case MESSAGE_DATA_LOADING:
        return {
          ...state,
          loading: actions.payload
        };
    default:
      return state;
  }
};

export const JoinChatReducer = (state = false, actions) => {
  switch (actions.type) {
    case JOIN_CHAT:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const MessageliveReducer = (state = false, actions) => {
  switch (actions.type) {
    case MESSAGE_LIVE:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const MessageindexReducer = (state = false, actions) => {
  switch (actions.type) {
    case MESSAGE_Index:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const MessageuploadReducer = (state = false, actions) => {
  switch (actions.type) {
    case MESSAGE_Upload:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const notificationReducer = (state = false, actions) => {
  switch (actions.type) {
    case NOTIFICATIONMESSAGE:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const statusReducer = (state = "", actions) => {
  switch (actions.type) {
    case STATUSCODE:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const adIdReducer = (state = "", actions) => {
  switch (actions.type) {
    case ADID:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const searchRecordReducer = (state = "", actions) => {
  switch (actions.type) {
    case SEARCHCOUNT:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const adsTypeReducer = (state = "", actions) => {
  switch (actions.type) {
    case ADSTYPE:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const filterReducer = (state = "", actions) => {
  switch (actions.type) {
    case MESSAGE_FILTER:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const deleteChannelCountReducer = (state = "", actions) => {
  switch (actions.type) {
    case DELETECHANNELS:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const seenMessageReducer = (state = "", actions) => {
  switch (actions.type) {
    case SEENMESSAGE:
      return (state = actions.payload);
    default:
      return state;
  }
};

export const seenMessageFirstCountReducer = (state = "", actions) => {
  switch (actions.type) {
    case SEENMESSAGEFIRST:
      return (state = actions.payload);
    default:
      return state;
  }
};


export const unblockUserIdReducer = (state = "", actions) => {
  switch (actions.type) {
    case UNBLOCKUSERID:
      return (state = actions.payload);
    default:
      return state;
  }
};
